/*
 * LP C finder (sections/lp-finder.liquid): three questions, one match and a runner-up.
 * Product data (names, live prices, review lines, images, URLs, availability) comes from the
 * #lp-finder-data JSON block rendered by Liquid. The match logic is the approved prototype's.
 * "Start again" resets in place: a reload would fire a second PageView in every pixel.
 */
(function () {
  'use strict';

  // [first answer][budget index] -> [match, runner-up]
  var TABLE = {
    quiet: [['petal', 'duo'], ['petal', 'duo'], ['duo', 'petal']],
    hands: [['contour', 'ring'], ['contour', 'ring'], ['contour', 'ring']],
    two: [['ring', 'contour'], ['ring', 'contour'], ['ring', 'contour']],
    first: [['pocket', 'petal'], ['petal', 'contour'], ['contour', 'petal']],
    pelvic: [['toner', 'set3'], ['set3', 'mix'], ['mix', 'set3']],
  };
  var TRAVEL = ['pocket', 'petal', 'duo'];
  var BUDGET_CAPS = [4000, 8000, 10000]; // in cents: under $40, $40 to $80, up to $100
  var STEPS = ['q1', 'q2', 'q3'];
  var KLAVIYO_REVISION = '2025-10-15';
  // Custom Shopify analytics event. The "Finder lead" custom pixel turns it into a Meta "Lead"
  // (see docs/custom-pixel-finder-lead.js). Published only after Klaviyo accepts the signup.
  var LEAD_EVENT = 'trc_finder_lead';

  function newEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function publishLead(matchName, runnerUpName) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    // No email or other personal data goes into the event.
    analytics.publish(LEAD_EVENT, {
      event_id: newEventId(),
      finder_match: matchName,
      finder_runner_up: runnerUpName,
      source: 'massager-finder',
    });
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cdnWidth(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function init() {
    var finder = document.getElementById('finder');
    var dataEl = document.getElementById('lp-finder-data');
    var result = document.getElementById('res');
    if (!finder || !dataEl || !result) return;

    var data = JSON.parse(dataEl.textContent);
    var products = data.products;
    var klaviyo = data.klaviyo;
    var bars = finder.querySelectorAll('.bar3 i');
    var answers = {};
    var match = null;
    var runnerUp = null;
    var busy = false;
    // Emails that already produced a lead on this page view, so "Start again" plus the same
    // email does not count twice. Kept in memory only.
    var leadEmails = {};

    function setBar(lastOn) {
      bars.forEach(function (bar, k) {
        bar.classList.toggle('on', k <= lastOn);
      });
    }

    function scrollToFinder() {
      var topbar = document.querySelector('.lp-trc .topbar');
      var offset = (topbar ? topbar.offsetHeight : 0) + 8;
      var top = finder.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    function choose(option) {
      if (busy) return;
      var step = option.getAttribute('data-q');
      var value = option.getAttribute('data-v');
      answers[step] = step === 'q2' ? parseInt(value, 10) : value;

      option.parentNode.querySelectorAll('.opt').forEach(function (o) {
        o.classList.remove('on');
      });
      option.classList.add('on');

      var i = STEPS.indexOf(step);
      setBar(i + 1);
      busy = true;
      setTimeout(function () {
        busy = false;
        document.getElementById(step).hidden = true;
        if (i < STEPS.length - 1) {
          document.getElementById(STEPS[i + 1]).hidden = false;
        } else {
          show();
        }
      }, 180);
    }

    function pick() {
      var pair = TABLE[answers.q1][answers.q2];
      var m = pair[0];
      var ru = pair[1];
      if (answers.q3 === 'water' && answers.q1 !== 'pelvic') {
        if (answers.q2 === 2) {
          ru = m;
          m = 'ring';
          if (ru === 'ring') ru = 'contour';
        } else if (m !== 'ring') {
          ru = 'ring';
        }
      }
      if (answers.q3 === 'travel' && answers.q1 !== 'pelvic' && answers.q1 !== 'two') {
        var t = TRAVEL[answers.q2];
        if (t !== m) {
          ru = m;
          m = t;
        }
      }
      return [m, ru];
    }

    function buyButton(product) {
      if (product.available && product.u) {
        return '<a class="btn block" href="' + esc(product.u) + '">Add to bag &middot; ' + esc(product.p) + '</a>';
      }
      return '<span class="btn block is-soldout" aria-disabled="true">Sold out</span>';
    }

    function emailBox() {
      if (!klaviyo) return '';
      return (
        '<div class="emailbox"><b style="color:var(--ink)">Want 10% off your first order?</b>' +
        '<div style="font-size:13px">We will email your match and a one-time code. Subject lines say TRC Wellness only. Optional.</div>' +
        '<form data-finder-email novalidate>' +
        '<input type="email" name="email" autocomplete="email" required placeholder="Email address" aria-label="Email address">' +
        '<button class="btn" type="submit">Send</button></form>' +
        '<div class="msg" role="status" hidden></div></div>'
      );
    }

    function show() {
      var keys = pick();
      match = products[keys[0]];
      runnerUp = products[keys[1]];
      var over = match.price > BUDGET_CAPS[answers.q2];

      result.innerHTML =
        '<div class="qn">' + (over ? 'Closest match, above your budget' : 'Your match') + '</div>' +
        '<div class="pick1" style="margin-top:10px">' +
        '<img src="' + esc(cdnWidth(match.img, 220)) + '" width="' + match.iw + '" height="' + match.ih + '" alt="' + esc(match.n) + '">' +
        '<div><div class="t">' + esc(match.n) + '</div>' +
        '<div style="font-size:12.5px;color:var(--muted);margin:3px 0 6px">' + esc(match.r) + '</div>' +
        '<div class="price" style="margin:0"><span class="now" style="font-size:24px">' + esc(match.p) + '</span></div></div></div>' +
        '<ul class="checklist" style="margin:12px 0">' +
        match.why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') +
        '</ul>' +
        buyButton(match) +
        '<div class="plainline">Plain box &middot; Neutral billing name &middot; 5-year warranty</div>' +
        '<div style="margin-top:14px;font-size:13px;color:var(--muted)">Runner-up: ' +
        '<a href="' + esc(runnerUp.u) + '" style="color:var(--accent-dk);font-weight:600">' +
        esc(runnerUp.n) + ', ' + esc(runnerUp.p) + '</a></div>' +
        emailBox() +
        '<p class="micro"><a href="#finder" data-finder-restart style="color:var(--accent-dk)">Start again</a></p>';
      result.classList.add('show');
      scrollToFinder();
    }

    function reset() {
      answers = {};
      match = null;
      runnerUp = null;
      result.classList.remove('show');
      result.innerHTML = '';
      STEPS.forEach(function (step, i) {
        document.getElementById(step).hidden = i !== 0;
      });
      finder.querySelectorAll('.opt.on').forEach(function (o) {
        o.classList.remove('on');
      });
      setBar(0);
      scrollToFinder();
    }

    function subscribe(form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      var msg = form.parentNode.querySelector('.msg');
      var email = input.value.trim();

      function say(text, isError) {
        msg.textContent = text;
        msg.classList.toggle('err', !!isError);
        msg.hidden = false;
      }

      if (form.getAttribute('data-busy')) return;
      if (!email || !input.checkValidity()) {
        say('Please enter a valid email address.', true);
        return;
      }

      form.setAttribute('data-busy', '1');
      button.disabled = true;
      msg.hidden = true;
      var matchName = match ? match.n : '';
      var runnerUpName = runnerUp ? runnerUp.n : '';
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'TRC Wellness LP finder',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    finder_match: matchName,
                    finder_runner_up: runnerUpName,
                  },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: klaviyo.list } } },
        },
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyo.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
          form.innerHTML = '<b>Sent. Check your inbox for your code.</b>';
          var key = email.toLowerCase();
          if (!leadEmails[key]) {
            leadEmails[key] = true;
            publishLead(matchName, runnerUpName);
          }
        })
        .catch(function () {
          form.removeAttribute('data-busy');
          button.disabled = false;
          say('Something went wrong. Please try again.', true);
        });
    }

    finder.addEventListener('click', function (event) {
      var option = event.target.closest('.opt');
      if (option && finder.contains(option)) {
        choose(option);
        return;
      }
      if (event.target.closest('[data-finder-restart]')) {
        event.preventDefault();
        reset();
      }
    });

    finder.addEventListener('submit', function (event) {
      if (event.target.matches('[data-finder-email]')) {
        event.preventDefault();
        subscribe(event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
